import { useEffect, useState } from "react";

type Breakpoint = "sm" | "md" | "lg" | "xl" | "2xl";

const breakpoints: Record<Breakpoint, number> = {
  sm: 40, // 640px
  md: 48, // 768px
  lg: 64, // 1024px
  xl: 80, // 1280px
  "2xl": 96, // 1536px
};

const getInitialMatches = (breakpoint: Breakpoint): boolean => {
  const query = window.matchMedia(`(min-width: ${breakpoints[breakpoint]}rem)`);
  return query.matches;
};

export const useBreakpoint = (breakpoint: Breakpoint): boolean => {
  const [matches, setMatches] = useState(getInitialMatches(breakpoint));

  useEffect(() => {
    const query = window.matchMedia(
      `(min-width: ${breakpoints[breakpoint]}rem)`,
    );
    setMatches(query.matches);

    const listener = (event: MediaQueryListEvent) => {
      setMatches(event.matches);
    };

    query.addEventListener("change", listener);
    return () => query.removeEventListener("change", listener);
  }, [breakpoint]);

  return matches;
};
